import { useStoreFly } from "../store";

// Safe JSON parser with fallback
const safeJSONParse = (str, fallback = []) => {
  try {
    const parsed = JSON.parse(str);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch (e) {
    console.warn("Failed to parse JSON from localStorage:", e);
    return fallback;
  }
};

export const useFlights = () => {
  const searchedFlightsByPrice = 
    useStoreFly((state) => state.flightsByPrice) || [];
  const searchedFlightsByDuration =
    useStoreFly((state) => state.flightsByDuration) || [];
  const searchedFlightsByDate =
    useStoreFly((state) => state.flightsByDate) || [];
  const searchedFlightsByQuality =
    useStoreFly((state) => state.flightsByQuality) || [];
 
  // Try localStorage first, fallback to memory store
  const getFlightData = (storageKey, memoryData) => {
    try {
      const storedData = localStorage.getItem(storageKey);
      if (storedData) {
        const parsed = safeJSONParse(storedData, []);
        return parsed.length > 0 ? parsed : memoryData;
      }
      return memoryData;
    } catch (e) {
      console.warn(`Error accessing localStorage for ${storageKey}:`, e);
      return memoryData;
    }
  };

  return {
    priceFlights: getFlightData("flightsByPrice", searchedFlightsByPrice),
    durationFlights: getFlightData("flightsByDuration", searchedFlightsByDuration),
    dateFlights: searchedFlightsByDate,
    qualityFlights: getFlightData("flightsByQuality", searchedFlightsByQuality),
  };
};
